/*eslint-disable import/default */
import configureStore from "./configureStore";
export default configureStore();
